export default __webpack_public_path__ + "static/media/12.5a0e1679.jpg";